/*
 * @Author: edvardchen
 * @Date:   2016-11-13 13:13:17
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-12-26 19:59:37
 */

import React from 'react';
import withCenterPosition from '../HOCs/withCenterPosition';
if (__CLIENT__) {
  require('./Loading.scss');
}

function Loading() {
  return (
    <div className="mod-loading">
      <div className="loading">
        <b className="block"></b>
        <b className="block"></b>
        <b className="block"></b>
      </div>
    </div>
  );
}

export const center = withCenterPosition(Loading);

export default Loading;
